import comp from "./ContentEditable";
export default comp;
